import type { PriceType } from "../../../../../common-deprecated/types/CommonTypes";
import type { CO2SpecsType } from "../../../../shared-logic/types/ConfigurationSpecificationsObjectType";

import type { ExternalPriceCalulatedPriceType } from "../../../../shared-logic/types/externalPriceTypes";

export const EXTERNAL_PRICE_SET_ENABLE = "externalPrice/setEnable" as const;
export const EXTERNAL_PRICE_SET_ERROR = "externalPrice/setError" as const;
export const START_EXTERNAL_PRICE_VALUE_FETCH = "externalPrice/startExternalPriceValueFetch" as const;
export const FINISH_EXTERNAL_PRICE_VALUE_FETCH = "externalPrice/finishExternalPriceValueFetch" as const;
export const FETCH_EXTERNAL_PRICE_FUNCTIONS = "externalPrice/fetchExternalPriceFunctions" as const;
export const SET_EXTERNAL_PRICE_CALCULATOR_READY = "externalPrice/setExternalPriceCalculatorReady" as const;
export const SET_EXTERNAL_PRICE_FUNCTION_FETCH = "externalPrice/setExternalPriceFunctionFetch" as const;
export const SET_EXTERNAL_PRICE_TAX_LOCATION = "externalPrice/setExternalPriceTaxLocation" as const;

export type SetExternalPriceEnableType = { type: typeof EXTERNAL_PRICE_SET_ENABLE; enable: boolean };
export type FetchExternalPriceFunctionsType = { type: typeof FETCH_EXTERNAL_PRICE_FUNCTIONS };
export type SetExternalPriceCalculatorReadyType = { type: typeof SET_EXTERNAL_PRICE_CALCULATOR_READY; ready: boolean };
export type StartExternalPriceFetchType = {
    type: typeof START_EXTERNAL_PRICE_VALUE_FETCH;
    originalTotalPrice: PriceType;
    firstTimeLoad: boolean;
};
export type FinishExternalPricePriceFetchType = {
    type: typeof FINISH_EXTERNAL_PRICE_VALUE_FETCH;
    calculatedPrice: ExternalPriceCalulatedPriceType;
    co2Specs: CO2SpecsType | null;
};
export type SetExternalPriceFunctionFetchType = { type: typeof SET_EXTERNAL_PRICE_FUNCTION_FETCH; fetching: boolean };
export type SetExternalPriceErrorType = { type: typeof EXTERNAL_PRICE_SET_ERROR; error: boolean };
export type SetExternalPriceTaxLocationType = {
    type: typeof SET_EXTERNAL_PRICE_TAX_LOCATION;
    locationId: string | null;
    triggerCalculation: boolean;
};

export const enableExternalPrice = (enable: boolean): SetExternalPriceEnableType => ({
    type: EXTERNAL_PRICE_SET_ENABLE,
    enable,
});

export const fetchExternalPriceFunctions = (): FetchExternalPriceFunctionsType => ({
    type: FETCH_EXTERNAL_PRICE_FUNCTIONS,
});
export const setExternalPriceCalculatorReady = (ready: boolean): SetExternalPriceCalculatorReadyType => ({
    type: SET_EXTERNAL_PRICE_CALCULATOR_READY,
    ready,
});
export const startExternalPriceValueFetch = (
    originalTotalPrice: PriceType,
    firstTimeLoad: boolean = false,
): StartExternalPriceFetchType => ({
    type: START_EXTERNAL_PRICE_VALUE_FETCH,
    originalTotalPrice,
    firstTimeLoad,
});
export const finishExternalPriceValueFetch = (
    calculatedPrice: ExternalPriceCalulatedPriceType,
    co2Specs: CO2SpecsType | null,
): FinishExternalPricePriceFetchType => ({
    type: FINISH_EXTERNAL_PRICE_VALUE_FETCH,
    calculatedPrice,
    co2Specs,
});
export const setExternalPriceFunctionFetch = (fetching: boolean): SetExternalPriceFunctionFetchType => ({
    type: SET_EXTERNAL_PRICE_FUNCTION_FETCH,
    fetching,
});
export const setExternalPriceError = (error: boolean): SetExternalPriceErrorType => ({
    type: EXTERNAL_PRICE_SET_ERROR,
    error,
});

export const setExternalPriceTaxLocation = (
    locationId: string | null,
    triggerCalculation: boolean = true,
): SetExternalPriceTaxLocationType => ({
    type: SET_EXTERNAL_PRICE_TAX_LOCATION,
    locationId,
    triggerCalculation,
});

export type ExternalPriceActionsType =
    | FetchExternalPriceFunctionsType
    | SetExternalPriceCalculatorReadyType
    | StartExternalPriceFetchType
    | FinishExternalPricePriceFetchType
    | SetExternalPriceFunctionFetchType
    | SetExternalPriceErrorType
    | SetExternalPriceEnableType
    | SetExternalPriceTaxLocationType;
